import { gql } from '@apollo/client'

export const DESTROY_CUSTOMER_SPREEDLY_CARD = gql`
  mutation DestroyCustomerSpreedlyCard($input: DestroyCustomerSpreedlyCardInput!) {
    destroyCustomerSpreedlyCard(input: $input) {
      customerSpreedlyCard {
        id
      }
    }
  }
`
